// TODO: remove all bulk order related code since it will not be implemented anymore epic DCPR-7997
export const config = {
  b2b_available_products: [] as string[],
};
